import { OperationFingerPrintLogData } from "../../data/operationFingerPrintLogData";
import { ServerResponse } from "../../data/serverResponse";
import { BaseLoginModel } from "../../models/auth/BaseLoginModel";
import { clientTime } from "../../utilities/index";
import { Http } from "./http";

/**Запросы к методам авторизации */
export class AuthApi {
  /**
   * Авторизация на сервере.
   * @param loginModel Данные авторизации.
   */
  static async loginAsync(loginModel: BaseLoginModel) {
    const data = {
      login: loginModel.Login,
      password: loginModel.Password,
      clientTime: clientTime(),
      typeSource: 0,
      newPassword: loginModel.NewPassword,
      code: loginModel.VerifyCode
    };

    const result: ServerResponse = await Http.post('webclient/Login', data);

    data.password = '****';

    const operationFingerPrintLog: OperationFingerPrintLogData = new OperationFingerPrintLogData('webclient/Login', '', data);

    await Http.post('FingerPrint/LogOperationFingerPrint', operationFingerPrintLog);

    return result;
  }

  /**
   * Проверка наличия сессии на сервере
   */
  static async sessionPing(): Promise<void> {
    await Http.get("WebClient/SessionPing");
  }

  /**
   * Проверка наличия сессии на сервере
   */
  static async logout(): Promise<void> {
    await Http.get("WebClient/Logout");
  }

  static async getEbsRegistrationLink(): Promise<any> {
    let result: any = Http.get(`EbsEsia/init?clientTime=${clientTime()}&source=0`);

    return result;
  }

  static async getSIDInformation(sid: string, resSecret: string): Promise<any> {
    let result: any = Http.get(`EbsEsia/GetResult?sessionId=${sid}&res_secret=${resSecret}&clientTime=${clientTime()}&source=0`);

    return result;
  }
}
